import React, { useEffect, useState } from 'react';
import { isChief, isManager, useUser } from '../contexts/UserContext';
import PdfList from '../pdf/PdfList';

const RapportsMaintenance = () => {

  //contexte de l'utilisateur connecté
  const user = useUser();
  const [collectionPath, setCollectionPath] = useState(null); 

  useEffect(()=>{

    if(isChief(user.user)){
      setCollectionPath(user.user.userData.clientId.path+"/rapports_maintenance")
    }

    if(isManager(user.user)){
      setCollectionPath("utilisateurs/"+user.user.user.uid+"/rapports_maintenance")
    }
  }, []); 

  return (    
    <div className='md:px-10 min-h-screen justify-center items-center bg-gray-100'>
      {collectionPath == null ? (
        <div className="animate-spin rounded-full border-t-2 border-b-2 border-white h-4 w-4 mr-2"></div>
      ) : (
        <PdfList collectionPath={collectionPath} nomSection={"Rapports de maintenance"}/>
      )}
    </div>
  );
};

export default RapportsMaintenance;
